/**
 * Converts a given string into a numeric value.
 *
 * @param {string} receivedString - The string to be converted.
 *
 * @returns {number | undefined} - Returns the numeric value of the string if conversion is successful.
 * If the input is invalid or cannot be converted, it returns `undefined`.
 *
 * @description
 * This function takes a string input. If the
 * input is null, undefined, or cannot be converted to a number, the function returns `undefined`.
 *
 * @example
 * // Example usage:
 * const size1 = convertStringToNumber('16'); // Returns: 16
 * const size3 = convertStringToNumber('abc');  // Returns: undefined
 * const size4 = convertStringToNumber(null);   // Returns: undefined
 */
export const convertStringToNumber = (receivedString: string): number | undefined => {
  return parseFloat(`${receivedString ?? ''}`) ?? Number(`${receivedString ?? ''}`) ?? undefined;
};
